var storage={
    set(key,value){
        sessionStorage.setItem(key, JSON.stringify(value));
    },
    get(key){
      if(sessionStorage.getItem(key)!=null){
        return JSON.parse(sessionStorage.getItem(key));
      }
         return null;
    },remove(key){
    sessionStorage.removeItem(key);
    }

}

export default storage;





// WEBPACK FOOTER //
// ./src/utils/storage.js